import './Text.styles.scss';

import PropTypes from 'prop-types';

import prepareClassNames from '../../utils/prepareClassNames';

const Text = ({ grey = false, name = '', small = false, additionalClasses = [], children }) => {
    const classNames = [
        name ? `${name}__text` : null,
        'text',
        grey ? 'text--grey' : null,
        small ? 'text--small' : null,
        ...additionalClasses,
    ];
    const classNamesJoined = prepareClassNames(classNames);

    return <p className={classNamesJoined}>{children}</p>;
};

Text.propTypes = {
    color: PropTypes.bool,
    name: PropTypes.string,
    small: PropTypes.bool,
    additionalClasses: PropTypes.array,
};

export default Text;
